import { Component, Input, OnInit } from "@angular/core";
import { Product } from "src/app/modals/product.model";
import { ProductService } from "src/app/components/shared/services/product.service";
import { ItemsService } from "src/app/services/items.service";
import { Router } from "@angular/router";
import { CartService } from "src/app/components/shared/services/cart.service";
import { CartDialogComponent } from "src/app/components/pages/cart-dialog/cart-dialog.component";
import { constApi } from "src/environments/constApi";
import { ObservService } from "src/app/services/observ.service";
import { NgxSpinnerService } from "ngx-spinner";
import { EcommerceNpService } from "src/app/components/shared/services/ecommerce-np.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-popular-products",
  templateUrl: "./popular-products.component.html",
  styleUrls: ["./popular-products.component.sass"],
})
export class PopularProductsComponent implements OnInit {
  // public products: Product[];
  public products: any[];
  public relacionado: any[]=[];
  public product: Product = {};
  codigoParam:any
  @Input()
  set codigo(value: string) {
    this.codigoParam = value;
    this.cargarRelacionados()
  }
  constructor(
    private productService: ProductService,
    private itemService: ItemsService,
    private router: Router,
    private cartService: CartService,
    private ecomservice: EcommerceNpService,
    private spinner: NgxSpinnerService,
  ) {}

  async ngOnInit() {
  }
  async cargarRelacionados(){
    this.products = []
    let paramPro = [{ clave: "tipo", valor: "RLP" }];
    let resProce: any = await this.obtenerEnum(paramPro);
    if(resProce != undefined){
      if(this.codigoParam != null){
        let item = resProce.body.find(x => x.Abrev == this.codigoParam)
        if(item != null){
          this.productService.getDestacados(item.ValorC).subscribe((res: any) => {
            this.products = res;
          });
        }
      }
    }
  }
  async selectProduct(item: any) {
    await this.itemService.sumarClic(item.idItemEC);
    this.router.navigate(["/home/product", item.idItemEC]);
  }
  public addToCart(product: Product, quantity: number = 1) {
    alert("Muy pronto estara disponible!")
    // if (quantity == 0 || product.SaldoG == 0) return false;

    // if (sessionStorage.getItem("tp") == null) {
    //   sessionStorage.setItem("tp", "TA");
    //   product.PVVenta = product.PV2;
    // } else {
    //   if (sessionStorage.getItem("tp") == "TA") {
    //     product.PVVenta = product.PV2;
    //   } else {
    //     product.PVVenta = product.PV3;
    //   }
    // }

    // this.cartService.addToCart(product, quantity);
    // this.dialog.open(CartDialogComponent, {
    //   data: null,
    //   panelClass: "product-dialog",
    //   width: "800px",
    // });
  }
  async obtenerEnum(param) {
    return await this.ecomservice
      .getParam(environment.apiUrlAdm,constApi.ENUMTIPO, param)
      .toPromise()
      .catch((error: any) => {
        this.spinner.hide();
      });
  }
}
